import React, { useState } from "react";
import { Mail, MapPin, Send } from "lucide-react";
import { contactAPI } from "../services/api";
import Seo from "../components/Seo";
import "./Contact.css";

export default function Contact() {
  const [formData, setFormData] = useState({ name: "", email: "", subject: "", message: "" });
  const [status, setStatus] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await contactAPI.submit(formData);
      setStatus("success");
      setFormData({ name: "", email: "", subject: "", message: "" });
      setTimeout(() => setStatus(""), 4000);
    } catch (err) {
      setStatus("error");
      setTimeout(() => setStatus(""), 4000);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-page" data-testid="contact-page">
      <Seo
        title="Contact"
        description="Get in touch with Race377 — story tips, press, partnerships and reader feedback."
      />

      <section className="contact-hero">
        <div className="container">
          <span className="caption">Race377</span>
          <h1 className="brand-display" style={{ marginTop: 12 }}>Get in touch</h1>
          <p className="body-large" style={{ color: "var(--text-secondary)", marginTop: 16, maxWidth: 640, fontSize: "1.1rem", fontWeight: 400 }}>
            Story tips, press releases, corrections, partnerships — we read every message.
          </p>
        </div>
      </section>

      <section className="container contact-body">
        <div className="contact-grid">
          <form className="contact-form" onSubmit={onSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input id="name" name="name" value={formData.name} onChange={onChange} required data-testid="contact-name" />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input id="email" name="email" type="email" value={formData.email} onChange={onChange} required data-testid="contact-email" />
            </div>
            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input id="subject" name="subject" value={formData.subject} onChange={onChange} required data-testid="contact-subject" />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" rows={7} value={formData.message} onChange={onChange} required data-testid="contact-message" />
            </div>
            <button type="submit" className="btn-primary" disabled={submitting} data-testid="contact-submit">
              <Send size={18} style={{ marginRight: 8 }} />
              {submitting ? "Sending…" : "Send message"}
            </button>
            {status === "success" && <p className="contact-status contact-status--ok" data-testid="contact-success">Message sent — we&apos;ll reply soon.</p>}
            {status === "error" && <p className="contact-status contact-status--err">Failed to send. Try again.</p>}
          </form>

          <aside className="contact-info">
            <h2 className="heading-3" style={{ marginBottom: 24 }}>Direct lines</h2>
            <div className="contact-info-item">
              <Mail size={20} />
              <div>
                <p className="caption">Editorial &amp; tips</p>
                <a href="mailto:editorial@race377.com">editorial@race377.com</a>
              </div>
            </div>
            <div className="contact-info-item">
              <Mail size={20} />
              <div>
                <p className="caption">Partnerships</p>
                <a href="mailto:hello@race377.com">hello@race377.com</a>
              </div>
            </div>
            <div className="contact-info-item">
              <MapPin size={20} />
              <div>
                <p className="caption">Based in</p>
                <p className="body-small">Mumbai, India</p>
              </div>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}
